import styled from "styled-components";
import TextGothic from "./utils/TextGothic";

const Copyright = () => {
  return (
    <Wrapper>
      <TextGothic size="12px" weight="normal">
        Copyright © ANA・ANA X
      </TextGothic>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default Copyright;
